// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"290":"5797e54c","372":"18b6beb2","453":"1f960028","585":"0e00459e","929":"8a73fcff","972":"80b4202a"}[chunkId] + ".chunk.js";
};